/**
 * isDev
 * @author donaldcen
 * @createTime 2017/11/24
 */

export default function () {
  return typeof window === 'object' && window.isDev
}


// WEBPACK FOOTER //
// ../src/jsbridge/package/src/libs/os/src/isDev.js